export type Theme = 'light' | 'dark'

/** Where the choice is remembered between visits. */
export const THEME_STORAGE_KEY = 'augrank.theme'

/**
 * Reads the stored preference, falling back to the operating system.
 *
 * Its own module rather than a second export from the component: "light and
 * dark both work, everywhere" (CLAUDE.md, Frontend rules) is a property of this
 * function more than of the button, and it is testable without rendering
 * anything.
 */
export function preferredTheme(storage: Pick<Storage, 'getItem'>, matchesDark: boolean): Theme {
  const stored = storage.getItem(THEME_STORAGE_KEY)
  if (stored === 'light' || stored === 'dark') return stored
  return matchesDark ? 'dark' : 'light'
}
